import React from 'react';
import { CalculatorIcon, ClipboardListIcon, DraftingCompassIcon, ListChecksIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  compass: DraftingCompassIcon,
  calculator: CalculatorIcon,
  wrench: WrenchIcon,
  checks: ListChecksIcon,
  clipboard: ClipboardListIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-red-600', 'bg-blue-700', 'bg-green-700', 'bg-orange-600', 'bg-purple-700'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-cream text-charcoal" data-id="element-27" data-mp="1ejnhx19po7qx">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="19katic36ysm8">
        <h2 id="bonos" className="font-anton text-3xl uppercase leading-tight sm:text-4xl" data-id="element-29" data-mp="19mdvzvlj6e7u">
          <span className="bg-cta px-1.5" data-id="element-30" data-mp="1jigxr0ch0au9">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-charcoal/80" data-id="element-31" data-mp="1jgdx7mdoyzba">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-semibold text-wood" data-id="element-32" data-mp="3trdqfmyvmz0g">GRATIS</strong> con tu
          compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="2lcoq50sxhrh">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-wood/20 bg-white text-left" data-id="element-34" data-mp="7icjvkw4503t" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-display text-xs font-black uppercase tracking-wider text-white ${BONUS_COLORS[i]}`} data-id="element-35" data-mp="ld54uyurv8hs">
                  <Icon size={12} aria-hidden="true" data-id="element-36" data-mp="vbcknedbrki7" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="10a5wl2cyr3g9">
                  <h3 className="font-display text-sm font-extrabold uppercase leading-tight" data-id="element-38" data-mp="akpfmbouqrej">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-charcoal/80 sm:text-sm" data-id="element-39" data-mp="5nyzxpgylxtn">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-charcoal/50 line-through decoration-red-600 decoration-2" data-id="element-40" data-mp="fklho5dzo8rg">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-wood bg-white px-3 py-2 font-display text-xs font-black uppercase leading-tight sm:text-sm" data-id="element-41" data-mp="13afw2rdyi5dt">
          <p data-id="element-42" data-mp="3519inymd3mvb">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-red-600" data-id="element-43" data-mp="351sxv7kmnx5n">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}